import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { queryLiquidityProviders, queryMerchant } from "../api/merchant";
import {
  selectCrossMerchant,
  setLiquidityProvidersMapping,
  setMerchantMapping,
} from "../reducer/crossMerchantSlice";
import { useAppDispatch, useAppSelector } from "../reducer/hooks";

const api = {
  queryMerchant,
  queryLiquidityProviders,
};

const CALL_MERCHANT_API_LOCATIONS = [
  "/crossMerchantTransferPath",
  "/crossMerchantTransferRequest",
  "/crossMerchantTransferTransactionRecord",
  "/clientBalance",
  "/approveAllowanceRequestRecord",
  "/contractSweepRequestRecord",
  "/sweepRequestRecord",
  "/transactionReport",
  "/tronRentResourceRecords",
];

const CALL_LIQUIDITY_PROVIDERS_API_LOCATIONS = CALL_MERCHANT_API_LOCATIONS;

export const useQueryCrossMerchant = () => {
  const dispatch = useAppDispatch();
  const { merchantMapping, liquidityProvidersMapping } =
    useAppSelector(selectCrossMerchant);
  const location = useLocation();

  // these query need permission, only call in certain location
  const isCallMerchantApi = CALL_MERCHANT_API_LOCATIONS.includes(
    location.pathname,
  );
  const isCallLiquidityProvidersApi =
    CALL_LIQUIDITY_PROVIDERS_API_LOCATIONS.includes(location.pathname);

  // prevent duplicate call across pages
  const isMerchantMappingEmpty = Object.keys(merchantMapping).length === 0;
  const isLiquidityProvidersMappingEmpty =
    Object.keys(liquidityProvidersMapping).length === 0;

  useEffect(() => {
    if (isCallMerchantApi && isMerchantMappingEmpty) {
      api
        .queryMerchant()
        .then((res) => dispatch(setMerchantMapping(res || [])));
    }

    if (isCallLiquidityProvidersApi && isLiquidityProvidersMappingEmpty) {
      api
        .queryLiquidityProviders()
        .then((res) => dispatch(setLiquidityProvidersMapping(res || [])));
    }
  }, [location]);
};
